
import styled from "styled-components";
import { responsive } from "Styles/Constants";
import { COLORS } from "Styles/Constants";

//IMAGES


export const OurSubjectsContainer = styled.div`

    .our_subjects_sections {
        padding: 100px 0;
        background-color: #FFF9EB;
        position: relative;
    }
    .our_subjects_sections ul.subjects-images-list {
        list-style: none;
        padding: 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
    }
    .our_subjects_sections ul.subjects-images-list li {
        padding: 15px;
    }
    .our_subjects_sections .mygrid-row {
        align-items: center;
    }
    .our_sub_content {
        max-width: 601px;
    }

    @media (max-width: 991px) {
        .our_subjects_sections ul.subjects-images-list {
            max-width: 80%;
            margin-top: 30px;
            margin-bottom: 0;
            margin-left: auto;
            margin-right: auto;
        }
    }  
        
    @media (max-width: 767px) {
        .our_subjects_sections{
            padding: 50px 0;
        }
    }
    

}`;

